var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", {
        staticStyle: { height: "1000px", width: "100%" },
        attrs: { id: "fileview" },
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: "预览",
            width: "70%",
            height: "700px",
            visible: _vm.videoVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.videoVisible = $event
            },
          },
        },
        [
          _c(
            "video",
            {
              staticStyle: { scrolling: "no", "background-color": "black" },
              attrs: {
                scrolling: "no",
                autoplay: "",
                height: "700px",
                width: "100%",
                src: _vm.url,
                controls: "controls",
              },
            },
            [_vm._v("Your browser does not support the video tag. ")]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: "预览",
            width: "70%",
            height: "700px",
            visible: _vm.audioVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.audioVisible = $event
            },
          },
        },
        [
          _c(
            "audio",
            {
              attrs: {
                autoplay: "",
                width: "100%",
                src: _vm.url,
                controls: "controls",
              },
            },
            [_vm._v("' Your browser does not support the audio tag. ")]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: "预览",
            width: "70%",
            height: "700px",
            visible: _vm.imageVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.imageVisible = $event
            },
          },
        },
        [_c("img", { attrs: { height: "700px", width: "100%", src: _vm.url } })]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: { title: "预览", width: "70%", visible: _vm.pdfVisible },
          on: {
            "update:visible": function ($event) {
              _vm.pdfVisible = $event
            },
          },
        },
        [
          _c("embed", {
            attrs: {
              src: _vm.url,
              type: "application/pdf",
              width: "100%",
              height: "100%",
              internalinstanceid: "81",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }